import React from 'react';

const SearchPageHeader = () => {
    return(
        <h1 className="main-heading display-4"><img height="52" src="https://cdn.jsdelivr.net/npm/simple-icons@v3/icons/github.svg" />itHub Stats</h1>
    );
}

export default SearchPageHeader